import {
  REQUEST_CONNECT_DEVICE,
  RECEIVE_CONNECT_DEVICE,
  RESET_REDUX,
  RECEIVE_CLOSE_DEVICE,
  RECEIVE_PING,
  SET_ACQUIRING,
  RECEIVE_HEALTH,
  RESET_HEALTH,
} from "../actions/index";
import produce from "immer";

const initialState = {
  connectionFetching: false,
  connectionEstablished: false,
  serialNumber: "",
  simulate: false,
  health: {
    checked: false,
    status: null,
    capHeight: null,
    sws: null,
  },
  acquiring: false,
  aLineData: {},
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case REQUEST_CONNECT_DEVICE: {
        draft.connectionFetching = true;
        draft.simulate = action.simulate;
        break;
      }

      case RECEIVE_CONNECT_DEVICE:
        if (action.error) {
          draft.connectionFetching = false;
          draft.serialNumber = "";
          draft.connectionEstablished = false;
          draft.simulate = action.simulate;
          break;
        } else {
          draft.connectionFetching = false;
          draft.connectionEstablished = true;
          draft.serialNumber = action.serialNumber;
          draft.simulate = action.simulate;
          break;
        }

      case RECEIVE_CLOSE_DEVICE: {
        draft.connectionFetching = false;
        draft.connectionEstablished = false;
        draft.simulate = false;
        draft.serialNumber = "";
        draft.aLineData = {};
        draft.health = {
          checked: false,
          status: null,
          capHeight: null,
          sws: null,
        };
        break;
      }

      case RECEIVE_PING: {
        draft.aLineData = action.response;
        break;
      }

      case SET_ACQUIRING: {
        draft.acquiring = action.status;
        break;
      }

      case RECEIVE_HEALTH: {
        draft.health = {
          checked: true,
          status: action.health,
          message: action.message,
          capHeight: action.capHeight,
          sws: action.sws,
        };
        break;
      }

      case RESET_HEALTH: {
        draft.health.checked = false;
        break;
      }

      case RESET_REDUX:
        return initialState;

      default:
        return draft;
    }
  });
